{
  "id": "campaign-099",
  "name": "Neglected Lane",
  "seed": "campaign:99",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "X,,.L__L,,,,",
    ",,T..__,,T,,",
    ",,...__x,,,,",
    ",i.i.__,i,i,",
    ",,,,,__..,,,",
    "X,%,,__..,#,",
    ",,%%,__.%,,,",
    ",,%,,__%%%,,",
    ",,,,,__,%,,,",
    "____________",
    "~~h,h__h,h,x",
    ",~,,,__,,,,,",
    ",i,i,__,i,i.",
    ",*,*,__,*.*.",
    ",T,,,__,,.T.",
    ",,,,i__i,...",
    "..x,,,,,,x..",
    "S...,,,X,,,,"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 9,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 11,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 0,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 7
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 99,
  "biome": "cemetery",
  "par": {
    "reel": 15289,
    "push": 9810,
    "selfPropelled": 8721,
    "tractor": 4518,
    "zeroTurn": 5591,
    "fairway": 4251
  },
  "routeTries": {
    "par": {
      "reel": 6,
      "push": 7,
      "selfPropelled": 20,
      "tractor": 24,
      "zeroTurn": 8,
      "fairway": 9
    }
  }
}
